<template>
  <div class="row link-contact">
    <router-link
      class="link-contact__link"
      :to="toRoute"
    >
      {{ $t('company.contactTable.linkContact') }}
    </router-link>
    <span class="link-contact__plus">+</span>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { findContactsRouteByUserType } from '../utils/ccdUtil'
export default {
  props: {
    queryParams: {
      type: Object,
      default: undefined,
    },
  },
  computed: {
    ...mapGetters('user', ['isEngineer', 'isTenant', 'isContractor']),
    routeName () {
      return findContactsRouteByUserType()
    },
    toRoute () {
      return { name: this.routeName, query: this.queryParams }
    },
  },
}
</script>
<style lang='scss' scoped>
.link-contact {
  width: 217px;
    height: 35px;
    font-size: 14px;
    border: solid 1px #6E7A91;
    border-radius: 100px;
    color: #0C3A58;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
  &__link {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: #0C3A58;
  }
  &__plus {
    font-size: 20px;
    position: absolute;
    right: 5%;
  }
}
</style>
